/**
 * Active Rectangle Games (from production config DB)
 * Last refreshed: 2026-09-23
 *
 * Only games in this list will appear on the showcase.
 * Update this list when new games are added to production.
 *
 * Casual games were removed on 2026-07-10 — Rectangle no longer supports
 * them (CASUAL/CRASH titles are also filtered out in dedupeAndNormalize).
 */
const ACTIVE_RECTANGLE_GAMES = new Set([
  // ── Rectangle Slots ──
  'aquarius-fortune-wheel',
  'aztecs-mystery',
  'battleship',
  'black-assassin',
  'capricorns-orb-of-fortune',
  'disco-fever',
  'eggy-pop',
  'farmageddon',
  'fiesta-blue',
  'fiesta-green',
  'fiesta-magenta',
  'fiesta-red',
  'firecrackers-fortune',
  'firecrackers-fortune-100',
  'fortune-pig',
  'gold-diggers',
  'golden-koi-trail',
  'inmate-outcuss',
  'iron-valor',
  'lucky-caramelo-1000',
  'lucky-caramelo-2',
  'lucky-duck',
  'lucky-fox',
  'lucky-panda',
  'lucky-snake',
  'lucky-turtle',
  'magic-circus',
  'money-mania',
  'pirates-treasure-reel',
  'pisces-realm-of-fortune',
  'prosperity-dragon',
  'prosperity-dragon-golden-reel',
  'prosperity-horse',
  'prosperity-mouse',
  'prosperity-ox',
  'prosperity-rabbit',
  'prosperity-tiger',
  'realm-of-thunder',
  'rudolphs-gift',
  'shapes-of-fortune',
  'shapes-of-fortune-xmas',
  'smash-fury',
  'solar-pong',
  'swaggy-caramelo',
  'swaggy-caramelo-super',
  'the-lone-fireball',
  'the-lucky-year',
  'tinkering-box',
  'treasures-of-hades',
  'wheel-of-wealth',
  'year-of-the-golden-horse',
  // ── New Slots (2026-04) ──
  'aries-reactor-of-fortune',
  // ── New Slots (2026-07) ──
  'firecrackers-fortune-2',
  'jeweled-guardian-1000',
  'mystic-tiger-1000',
  'pirates-treasure-reel-2',
  'prism-riches',
  'realm-of-thunder-2',
  'super-lucky-caramelo',
  'treasures-of-hades-2',

  // ── New Slots (2026-08) ──
  'galactic-gold-rush',
  'skeleton-jewels',

  // ── New Slots (2026-09) ──
  'aphrodite-kiss-of-fortune',
]);

export default ACTIVE_RECTANGLE_GAMES;
